import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {NavigationEnd, Router} from '@angular/router';
import {Product} from '@app/core/product/domain/dtos/product';
import {PopupDispatcher} from '@app/presentation/components/errors/popup.dispatcher';
import {NoStockServiceViewModel} from '../no-stock-service.view-model';
import {routesNames} from "@app/app-routing.module";
import {map, share, startWith} from "rxjs/operators";

@Component({
  selector: 'app-no-stock-bottom-sheet',
  templateUrl: './no-stock-bottom-sheet.component.html',
  styleUrls: ['./no-stock-bottom-sheet.component.scss']
})
export class NoStockBottomSheetComponent implements OnInit {

  products: Product[] = [];
  similarProducts$ = this.viewModel.getSimilarProductsSucceed$.pipe(share())
  routesNames = routesNames;

  isSimilarProductsLoading$ = this.viewModel.isSimilarProductsLoading$

  canDisplaySimilarProduct$ = this.similarProducts$.pipe(
      map(similarProducts => similarProducts.length > 0 ),
      startWith(true),
  )

  constructor(
    private viewModel: NoStockServiceViewModel,
    private popupDispatcher: PopupDispatcher,
    private router: Router,
    private bottomSheetRef: MatBottomSheetRef,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      products: Product[]
    }
  ) {
    this.popupDispatcher.setNotifier(viewModel.notifier);
    this.router.events.subscribe({
      next: event => {
        if (event instanceof NavigationEnd) {
          this.closeBottomSheet();
        }
      }
    })
  }

  ngOnInit(): void {
    if (this.data) {
      this.products = this.data.products;
      const firstThreeProductsCodes = this.products.slice(0, 3).map(product => product.code) ?? [];
      this.viewModel.getSimilarProducts(firstThreeProductsCodes);
    }
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

}
